"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionVisitor = void 0;
var Settings_1 = require("./Settings");
var ExpressionVisitor = /** @class */ (function () {
    function ExpressionVisitor(settings) {
        if (settings === void 0) { settings = Settings_1.Settings.default; }
        this.settings = settings;
    }
    ExpressionVisitor.prototype.process = function (exp, scopes) {
        if (exp.type === "Func" /* Func */) {
            return this.visitFunc(exp, scopes);
        }
        return this.visit(exp, scopes);
    };
    ExpressionVisitor.prototype.visit = function (exp, scopes) {
        switch (exp.type) {
            case "Array" /* Array */: return this.visitArray(exp, scopes);
            case "Binary" /* Binary */: return this.visitBinary(exp, scopes);
            case "Call" /* Call */: return this.visitCall(exp, scopes);
            case "Indexer" /* Indexer */: return this.visitIndexer(exp, scopes);
            case "Literal" /* Literal */: return this.visitLiteral(exp, scopes);
            case "Member" /* Member */: return this.visitMember(exp, scopes);
            case "Object" /* Object */: return this.visitObject(exp, scopes);
            case "Ternary" /* Ternary */: return this.visitTernary(exp, scopes);
            case "Unary" /* Unary */: return this.visitUnary(exp, scopes);
            case "Variable" /* Variable */: return this.visitVariable(exp, scopes);
            case "Group" /* Group */:
                var gexp = exp;
                if (gexp.expressions.length === 1) {
                    return this.visit(gexp.expressions[0], scopes);
                }
            case "Assign" /* Assign */:
            case "Func" /* Func */:
                throw new Error("Invalid " + exp.type + " expression usage");
            default: throw new Error("Unsupported ExpressionType " + exp.type);
        }
    };
    ExpressionVisitor.prototype.visitArray = function (exp, scopes) {
        var _this = this;
        return exp.items.map(function (i) { return _this.visit(i, scopes); });
    };
    ExpressionVisitor.prototype.visitBinary = function (exp, scopes) {
        var e = exp;
        return this.evalBinary(this.visit(e.left, scopes), e.operator, e.right, scopes);
    };
    ExpressionVisitor.prototype.visitCall = function (exp, scopes) {
        var _this = this;
        var c = this.visit(exp.callee, scopes);
        var a = exp.args.map(function (x) { return x.type === "Func" /* Func */
            ? _this.visitFunc(x, scopes)
            : _this.visit(x, scopes); });
        return c.apply(void 0, a);
    };
    ExpressionVisitor.prototype.visitFunc = function (exp, scopes) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var s = {};
            exp.parameters.forEach(function (p, i) { return s[p] = args[i]; });
            return _this.visit(exp.body, __spreadArrays([s], scopes));
        };
    };
    ExpressionVisitor.prototype.visitIndexer = function (exp, scopes) {
        var e = exp;
        var o = this.visit(e.owner, scopes);
        var k = this.visit(e.key, scopes);
        return o != null ? o[k] : null;
    };
    ExpressionVisitor.prototype.visitLiteral = function (exp, scopes) {
        return exp.value;
    };
    ExpressionVisitor.prototype.visitMember = function (exp, scopes) {
        return this.readVar(exp.name, [this.visit(exp.owner, scopes)]);
    };
    ExpressionVisitor.prototype.visitObject = function (exp, scopes) {
        var _this = this;
        var o = {};
        exp.members.forEach(function (m) { return o[m.name] = _this.visit(m.right, scopes); });
        return o;
    };
    ExpressionVisitor.prototype.visitTernary = function (exp, scopes) {
        var e = exp;
        return this.visit(e.predicate, scopes)
            ? this.visit(e.whenTrue, scopes)
            : this.visit(e.whenFalse, scopes);
    };
    ExpressionVisitor.prototype.visitUnary = function (exp, scopes) {
        var value = this.visit(exp.target, scopes);
        var op = this.settings.getUnaryOperator(exp.operator);
        if (!op) {
            throw new Error("Unknown unary operator " + exp.operator);
        }
        return op(value);
    };
    ExpressionVisitor.prototype.visitVariable = function (exp, scopes) {
        return this.readVar(exp.name, scopes);
    };
    ExpressionVisitor.prototype.evalBinary = function (leftValue, operator, right, scopes) {
        var _a;
        var _this = this;
        var op = this.settings.getBinaryOperator(operator);
        if (!op) {
            throw new Error("Unknown binary operator " + operator);
        }
        if (["&&", "||"].indexOf(operator) !== -1) {
            return op.func(leftValue, function () { return _this.visit(right, scopes); });
        }
        var rightValue = this.visit(right, scopes);
        _a = this.tryFixDate(leftValue, rightValue), leftValue = _a[0], rightValue = _a[1];
        return op.func(leftValue, rightValue);
    };
    ExpressionVisitor.prototype.readVar = function (prop, scopes) {
        var scope = scopes.find(function (s) { return s && prop in s; });
        var v = scope && scope[prop];
        return (v && v.bind && typeof v.bind === "function") ? v.bind(scope) : v;
    };
    ExpressionVisitor.prototype.tryFixDate = function (v1, v2) {
        if (Object.prototype.toString.call(v1) === "[object Date]") {
            v1 = v1.getTime();
            if (typeof v2 === "string") {
                v2 = Date.parse(v2);
            }
        }
        return [v1, v2];
    };
    return ExpressionVisitor;
}());
exports.ExpressionVisitor = ExpressionVisitor;
//# sourceMappingURL=ExpressionVisitor.js.map